
import api from "./api.js";
import NewAndEventCustom from "../../components/NewAndEventCustom.vue";
import BreadCrumbs from "../../components/BreadCrumbs.vue";
export default {
  components: {
    NewAndEventCustom, BreadCrumbs
  },
  data() {
    return {
      newsAndEvents: [],
      breadCrumbs: [
        {
          text: "Home",
          to: "/", exact: true,
        },
        {
          text: "News And Event", to: "/news-and-events", exact: true,
        },
      ],
    };
  },
  mounted() {
    api.getNewsAndEvents().then((res) => {
      if (res.data.responseCode === 1) {
        this.newsAndEvents = res.data.data;
      }
    });
  },
};

